import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import dayjs from "dayjs";
import { Col, Row } from "antd";
import Button from "~/components/Button";
import Loading from "~/components/Loading";
import { Icon } from "~/components";
import {
	InputField,
	DateField,
	TextAreaField,
} from "~/components/Forms";

// Form thêm 1 liên hệ vào nguồn gọi điện
// Chấp nhận cả di động (10 số) và số cố định (11 số)
const phoneRegExp = /^0\d{9,10}$/;

function SaleCallSourceContactForm({ onHandleSubmit, onCancel }) {

	const initialValues = {
		name:           '',
		phone:          '',
		address:        '',
		website:        '',
		websiteExpired: null,
		note:           '',
	};

	const validationSchema = Yup.object().shape({
		name:  Yup.string().required('Bạn chưa điền tên khách hàng'),
		phone: Yup.string()
			.matches(phoneRegExp, 'Số điện thoại không hợp lệ (0xxxxxxxxx)')
			.required('Bạn chưa điền số điện thoại'),
	});

	const { control, handleSubmit, formState: { isSubmitting, errors } } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema),
	});

	const onSubmit = async (data) => {
		const payload = {
			...data,
			websiteExpired: data.websiteExpired ? dayjs(data.websiteExpired).format('YYYY-MM-DD') : null,
		};
		await onHandleSubmit(payload);
	};

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading />}
			<p className="heading">Thông tin liên hệ</p>
			<Controller control={control} name="name" render={({ field }) => (
				<InputField label="Tên (khách hàng / công ty)" errors={errors} {...field} />
			)} />
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="phone" render={({ field }) => (
						<InputField label="Số điện thoại" errors={errors} {...field} />
					)} />
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="address" render={({ field }) => (
						<InputField label="Địa chỉ" errors={errors} {...field} />
					)} />
				</Col>
			</Row>
			<p className="heading">Website</p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="website" render={({ field }) => (
						<InputField label="Website" placeholder="https://..." errors={errors} {...field} />
					)} />
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="websiteExpired" render={({ field }) => (
						<DateField label="Ngày hết hạn website" errors={errors} {...field} />
					)} />
				</Col>
			</Row>
			<Controller control={control} name="note" render={({ field }) => (
				<TextAreaField label="Ghi chú" errors={errors} {...field} />
			)} />
			<hr />
			<div className="form-group d-flex justify-content-end modal-bottom gap">
				{onCancel && <Button white type="button" onClick={onCancel}>Đóng</Button>}
				<Button primary type="submit" leftIcon={Icon.plus}>Thêm liên hệ</Button>
			</div>
		</form>
	);
}

export default SaleCallSourceContactForm;
